import { render, staticRenderFns } from "./CommentWriting.vue?vue&type=template&id=195822ea&scoped=true"
import script from "./CommentWriting.vue?vue&type=script&lang=js"
export * from "./CommentWriting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195822ea",
  null
  
)

export default component.exports